import { SimpleForm, SimpleFormProps, TextInput, required, BooleanInput } from 'react-admin';

export default function UtilityCategoriesForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        fullWidth
        autoComplete="off"
        label="Nome"
        source="name"
        validate={[required()]}
      />
      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
